"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserStorage = void 0;
const WATCH_STORAGE_KEY = 'da-ddt.watched';
exports.BrowserStorage = {
    loadList: () => {
        if (typeof localStorage === 'undefined') {
            return [];
        }
        let stored;
        try {
            stored = localStorage.getItem(WATCH_STORAGE_KEY);
        }
        catch (e) {
            return [];
        }
        if (!stored) {
            return [];
        }
        return stored.split(',');
    },
    saveList: (list) => {
        if (typeof localStorage === 'undefined') {
            return;
        }
        const toStore = list.join(',');
        localStorage.setItem(WATCH_STORAGE_KEY, toStore);
    },
};
//# sourceMappingURL=storage.js.map